var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlamingo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg54565",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    sodipodiDocname: "flamingo.svg",
    inkscapeVersion: "1.2.2 (732a01da63, 2022-12-09)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs54569"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview54567",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "true",
    inkscapeZoom: 17.521739,
    inkscapeCx: 24.512407,
    inkscapeCy: 26.024814,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1009,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g54571"
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid113908"
  }))), /*#__PURE__*/React.createElement("g", {
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Image",
    id: "g54571"
  }, /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    style: {},
    xlinkHref: "dataImage/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAEAAAAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4 QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgAMgAyAwERAAIRAQMR Af/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQEC AwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNE RUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqy s7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEB AQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEH YXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZX WFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLD xMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAQEBAQEBAQEBAQEB AQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/bAEMBAQEBAQEB AQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEB Af/dAAQAB//aAAwDAQACEQMRAD8A/v4oAKACgD8/v20f2ydS/Z5vPBXgL4cWHw/8Q/FDxz4g8EeG VTxj438LQWfhDxF8YNd1jwH+zp4X1TwGPGHhrxpqOv8A7SvxU0HxH4J+Gmq6veeAPhdBoHw2+Oni S6+J+pfFHwB8Nf2e/j6AfAPh/wD4LCeNPDP7T+tfA34r+BdA/sXw38QL/wCF3im3n8CeL/hJ8XPB mu+F9Ai+IHxB8Sar8PovHvx4PiXQfCnwl0fxj8YdDg8H3GoWHxI+C9voXxr8JeLD8ONZtNSvwD9/ 6ACgD//Q/v4oAKACgD8MP23/ABp4y/ZR/wCChXwN/am8UfDbUPiX8F/iX4P+GPwc8JX/AIR1iK+8 YfDz4ifBDwJ/wUN+Jfxp0j/hDbrTmnstO+J3wI+LUPxUtvFOlajb+ENQX9jnXPDnxd1vwFcn4N6l 4iAPAP8Agr54F/Z2XTv2ev2o/hr+zB+3Z8a/HH7SnxP+FniH4qeKv+Cc3wK8UfFf4ieKf2ffAHwv 8R6pHr3xK+H/AIt+Huu/BmLUfGVvq/wj+D7eIvFOtfA79o+/8InwXqfhrx9438Ffsv3XwdugD+gr 4Uaz478R/C74a+Ifij4U/wCEC+JmueAPB+s/EXwN9p0a7/4Qvx5qfhzTr7xb4S+1eHPEnjbQLv8A 4RzXp9Q0oXGh+MfF2jz/AGYzab4k1yzFtql0AeiUAf/R/v4oA/N39vn9unXf2WvBOoQfBvwL4B+K vxazqlm9n8SfivZ/Cz4ceB72Pwld+I9KPie60vQfG/xN8d6/qF5d+DdMh+HPwe+HPjHX9Hg8f+CP Fnxg1r4KfCbxJa/Fm1AP59dS/bq/4Kxaf8W4vjl4w/a31C1+BHirxho+q/CX4UeB/wBjT4QfCH4J +NPDfw3v7LRvG+gX+s/EsftK/GbWdN8bT2dj/wALAg8HftMrr/gDWfEHiTTfCfj7TrY+E/8AhHQD 6v8AjP8A8FNPFX7Sv7EH7Snwi+IXwZ/4Rn4raz8AtL8J/Cr4+fDe91CTwH4f/bPv/CXjfXvhx8VB o2swzeJP2dP+FYfGHwJ4H+NPwI1zw58R/jR8V/C+seF9T1vRNStvFnwe0fxZ4wAPv3/gix8StR8d /stePfC17d/aLb4L/H7xR8NdIh8/wrJ9g0/Vfhz8KvjJLaeV4dvrrV7TOr/FnVb0weObfSPFBF99 pttOl8F3HhDUtSAP2AoAKAP/0v7+KAP4Zvgd+y1/wVR/aV/ZyX/gpf8AtOfC/wC2+Ivit8X/ABH8 bPi/+zJ4ek+IGqftD+NP2bPElteSeHNT/Zu8L6/e+KovhB/wqvw1ZeCNE8D/ALPV74b+MHj/AOI/ wn0DWvF3hvT9b+P1zofw2+NwB7/p3x3/AOCefxE13xH8V/2kvjz4hs/HGu/2R4P1X4L/AA//AGJ/ 2s9bk/Z0+IPwotZvDvin4B/EX4afs8+D9f1H4Yn4fadpHwl8H2Gh+OfF3g/4kXPw4uPiR4S8S+CP hv8AGK2034gfD8A8f+Ov7SFn+0T8a1+A37GXwu8Qa18OfEv2n4o+Ef2efhp+zxoPhT4++PPF2ufF /wCJvgjwv8VfiNo8U2veMfhL+zH4b8H6v4GsvhL4/wD2hPG/wP8AA3wv8Y/Hf4x6J+0PofwU0TTf g38KPgUAf07/APBMf9imz/YF/Y4+GPwH1Gfw/r3xcvBq/wAVP2mPiH4fsdCgt/in+0x8VL9vFvxk 8ZDU9G8B/DmfX9At/Et6fBPwyvvEXhOw8T6R8GPCHw38Jazubw1b7QD9A6ACgD//0/7+KAMnVb26 07S9Uv7TSNQ1+8sbG7vLbQtKl0qDVNbntraWWHS9Nm13U9F0OLUdRljFpYy6vq2j6R9puIf7R1PT 7UT3duAfwuf8FJvB/hL9vL9mL9rH9vnxF8b/ABD8OP8Ago1ougfskfs6+HP+Cf8Areo+N/g5Zfse fBj4o/tkfBXS/hjo/wC2F+zr8QfAnhX4qfG34gax4W/aD+Kcvjbxx8RfAus/sv8AiDw/8d/EnhH4 SeCfijoXgjwR8a/FwB/Yr+yD+xv+zn+wh8EPDX7PP7L/AMNPD/wx+HHh/wAu8vIdKsrSPXPGvik6 VpOjan4/+IWvxQQ6j41+IOvadoWkwa14q1yefUbix03TNLgNvouj6VpungH1JQAUAFAH/9T+/igA oA/D/wD4L9/Cf4W+L/2DLv4o+K/hr4A8T/Ez4P8Ax/8A2MB8JviJ4h8HeHNd8efC/wD4WB+3h+yl 4c8d/wDCuvF2qabd694JHjXQLS30PxePDl9po8T6PbW+m619ss4EhoA+3f2U/wBijw7+yN8SPj9q 3wy8aeIdM+BXxR/4V1D8J/2Y7PxB8VLv4Q/s6QeEpviBrvjKX4YeFfiD8WviH4P8BD4keMPiTqZu PCHwJ8HfAn4NeFvh/wCCfhP4K8OfCZdR8I65428YAH3HQAUAFAH/1f7+KACgDhviB8P/AAF8V/CG vfDn4peCfCPxJ+Hvi+wuNJ8WeBPH3hrRvGPg3xPpT3tq76Z4i8L+IrLUdE1vT3eON2s9Ssbm2ZkQ mIlVKgB8P/h/4C+FHhDQfhz8LfBPhH4bfD3whYW+k+E/AngHw1o3g7wb4Y0pL26dNM8O+F/Dtlp2 iaJp6PJI62em2NtbKzuRECzFgDuaACgAoA//2Q== ",
    id: "image54573"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g122299"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113906",
    width: 1,
    height: 1,
    x: 37,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113910",
    width: 1,
    height: 1,
    x: 37,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113912",
    width: 1,
    height: 1,
    x: 36,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113914",
    width: 1,
    height: 1,
    x: 37,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113916",
    width: 1,
    height: 1,
    x: 38,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113918",
    width: 1,
    height: 1,
    x: 38,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113920",
    width: 1,
    height: 1,
    x: 39,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113922",
    width: 1,
    height: 1,
    x: 39,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113924",
    width: 1,
    height: 1,
    x: 40,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113926",
    width: 1,
    height: 1,
    x: 38,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113928",
    width: 1,
    height: 1,
    x: 37,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113930",
    width: 1,
    height: 1,
    x: 37,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113932",
    width: 1,
    height: 1,
    x: 35,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113934",
    width: 1,
    height: 1,
    x: 34,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113936",
    width: 1,
    height: 1,
    x: 34,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113938",
    width: 1,
    height: 1,
    x: 33,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113940",
    width: 1,
    height: 1,
    x: 29,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113942",
    width: 1,
    height: 1,
    x: 28,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113944",
    width: 1,
    height: 1,
    x: 30,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113946",
    width: 1,
    height: 1,
    x: 27,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113948",
    width: 1,
    height: 1,
    x: 27,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113950",
    width: 1,
    height: 1,
    x: 27,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113952",
    width: 1,
    height: 1,
    x: 27,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113954",
    width: 1,
    height: 1,
    x: 27,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113956",
    width: 1,
    height: 1,
    x: 28,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113958",
    width: 1,
    height: 1,
    x: 29,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113960",
    width: 1,
    height: 1,
    x: 29,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113962",
    width: 1,
    height: 1,
    x: 30,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113964",
    width: 1,
    height: 1,
    x: 31,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113966",
    width: 1,
    height: 1,
    x: 31,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113968",
    width: 1,
    height: 1,
    x: 31,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113970",
    width: 1,
    height: 1,
    x: 31,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113972",
    width: 1,
    height: 1,
    x: 34,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113974",
    width: 1,
    height: 1,
    x: 27,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113976",
    width: 1,
    height: 1,
    x: 24,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113978",
    width: 1,
    height: 1,
    x: 22,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113980",
    width: 1,
    height: 1,
    x: 21,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113982",
    width: 1,
    height: 1,
    x: 20,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113984",
    width: 1,
    height: 1,
    x: 19,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113986",
    width: 1,
    height: 1,
    x: 18,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113988",
    width: 1,
    height: 1,
    x: 19,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113990",
    width: 1,
    height: 1,
    x: 18,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113992",
    width: 1,
    height: 1,
    x: 17,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113994",
    width: 1,
    height: 1,
    x: 16,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113996",
    width: 1,
    height: 1,
    x: 15,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect113998",
    width: 1,
    height: 1,
    x: 14,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114000",
    width: 1,
    height: 1,
    x: 13,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114002",
    width: 1,
    height: 1,
    x: 10,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114004",
    width: 1,
    height: 1,
    x: 9,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114006",
    width: 1,
    height: 1,
    x: 9,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114008",
    width: 1,
    height: 1,
    x: 8,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114010",
    width: 1,
    height: 1,
    x: 8,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114012",
    width: 1,
    height: 1,
    x: 8,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114014",
    width: 1,
    height: 1,
    x: 8,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114016",
    width: 1,
    height: 1,
    x: 9,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114018",
    width: 1,
    height: 1,
    x: 9,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114020",
    width: 1,
    height: 1,
    x: 9,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114022",
    width: 1,
    height: 1,
    x: 10,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114024",
    width: 1,
    height: 1,
    x: 12,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114026",
    width: 1,
    height: 1,
    x: 13,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114028",
    width: 1,
    height: 1,
    x: 13,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114030",
    width: 1,
    height: 1,
    x: 14,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114032",
    width: 1,
    height: 1,
    x: 15,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114034",
    width: 1,
    height: 1,
    x: 16,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114036",
    width: 1,
    height: 1,
    x: 17,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114038",
    width: 1,
    height: 1,
    x: 18,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114040",
    width: 1,
    height: 1,
    x: 20,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114042",
    width: 1,
    height: 1,
    x: 21,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114044",
    width: 1,
    height: 1,
    x: 22,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114046",
    width: 1,
    height: 1,
    x: 23,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114048",
    width: 1,
    height: 1,
    x: 24,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114050",
    width: 1,
    height: 1,
    x: 25,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114052",
    width: 1,
    height: 1,
    x: 27,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114054",
    width: 1,
    height: 1,
    x: 27,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114056",
    width: 1,
    height: 1,
    x: 28,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114058",
    width: 1,
    height: 1,
    x: 34,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114060",
    width: 1,
    height: 1,
    x: 34,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114062",
    width: 1,
    height: 1,
    x: 34,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114064",
    width: 1,
    height: 1,
    x: 33,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114066",
    width: 1,
    height: 1,
    x: 33,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114068",
    width: 1,
    height: 1,
    x: 33,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114070",
    width: 1,
    height: 1,
    x: 32,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114072",
    width: 1,
    height: 1,
    x: 32,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114074",
    width: 1,
    height: 1,
    x: 32,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114076",
    width: 1,
    height: 1,
    x: 31,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114078",
    width: 1,
    height: 1,
    x: 30,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114080",
    width: 1,
    height: 1,
    x: 29,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114082",
    width: 1,
    height: 1,
    x: 28,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114084",
    width: 1,
    height: 1,
    x: 27,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114086",
    width: 1,
    height: 1,
    x: 26,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114088",
    width: 1,
    height: 1,
    x: 25,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114090",
    width: 1,
    height: 1,
    x: 24,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114092",
    width: 1,
    height: 1,
    x: 23,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114094",
    width: 1,
    height: 1,
    x: 24,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114096",
    width: 1,
    height: 1,
    x: 19,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114098",
    width: 1,
    height: 1,
    x: 19,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114100",
    width: 1,
    height: 1,
    x: 19,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114102",
    width: 1,
    height: 1,
    x: 20,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114104",
    width: 1,
    height: 1,
    x: 20,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114106",
    width: 1,
    height: 1,
    x: 21,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114108",
    width: 1,
    height: 1,
    x: 22,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114110",
    width: 1,
    height: 1,
    x: 23,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114112",
    width: 1,
    height: 1,
    x: 23,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114114",
    width: 1,
    height: 1,
    x: 23,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114116",
    width: 1,
    height: 1,
    x: 24,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114118",
    width: 1,
    height: 1,
    x: 25,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114120",
    width: 1,
    height: 1,
    x: 26,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114122",
    width: 1,
    height: 1,
    x: 27,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114124",
    width: 1,
    height: 1,
    x: 27,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114126",
    width: 1,
    height: 1,
    x: 26,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114128",
    width: 1,
    height: 1,
    x: 21,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114130",
    width: 1,
    height: 1,
    x: 20,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114132",
    width: 1,
    height: 1,
    x: 19,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114134",
    width: 1,
    height: 1,
    x: 18,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114136",
    width: 1,
    height: 1,
    x: 17,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114138",
    width: 1,
    height: 1,
    x: 16,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114140",
    width: 1,
    height: 1,
    x: 16,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114142",
    width: 1,
    height: 1,
    x: 17,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114144",
    width: 1,
    height: 1,
    x: 18,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114146",
    width: 1,
    height: 1,
    x: 23,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114148",
    width: 1,
    height: 1,
    x: 24,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114150",
    width: 1,
    height: 1,
    x: 22,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114152",
    width: 1,
    height: 1,
    x: 22,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114154",
    width: 1,
    height: 1,
    x: 22,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114156",
    width: 1,
    height: 1,
    x: 22,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114158",
    width: 1,
    height: 1,
    x: 22,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114160",
    width: 1,
    height: 1,
    x: 22,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114162",
    width: 1,
    height: 1,
    x: 22,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114164",
    width: 1,
    height: 1,
    x: 22,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114166",
    width: 1,
    height: 1,
    x: 22,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114168",
    width: 1,
    height: 1,
    x: 22,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114170",
    width: 1,
    height: 1,
    x: 22,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114172",
    width: 1,
    height: 1,
    x: 22,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114174",
    width: 1,
    height: 1,
    x: 22,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114176",
    width: 1,
    height: 1,
    x: 22,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114178",
    width: 1,
    height: 1,
    x: 22,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114180",
    width: 1,
    height: 1,
    x: 21,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 0.989851
    },
    id: "rect114182",
    width: 1,
    height: 1,
    x: 19,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114184",
    width: 1,
    height: 1,
    x: 38,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114666",
    width: 1,
    height: 1,
    x: 40,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114668",
    width: 1,
    height: 1,
    x: 40,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114670",
    width: 1,
    height: 1,
    x: 39,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114672",
    width: 1,
    height: 1,
    x: 39,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114674",
    width: 1,
    height: 1,
    x: 38,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114676",
    width: 1,
    height: 1,
    x: 37,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114678",
    width: 1,
    height: 1,
    x: 36,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114680",
    width: 1,
    height: 1,
    x: 35,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114682",
    width: 1,
    height: 1,
    x: 36,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114684",
    width: 1,
    height: 1,
    x: 37,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114686",
    width: 1,
    height: 1,
    x: 38,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114688",
    width: 1,
    height: 1,
    x: 39,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114690",
    width: 1,
    height: 1,
    x: 39,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114692",
    width: 1,
    height: 1,
    x: 39,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114694",
    width: 1,
    height: 1,
    x: 38,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114696",
    width: 1,
    height: 1,
    x: 38,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114698",
    width: 1,
    height: 1,
    x: 38,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114700",
    width: 1,
    height: 1,
    x: 37,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114702",
    width: 1,
    height: 1,
    x: 36,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114704",
    width: 1,
    height: 1,
    x: 35,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114706",
    width: 1,
    height: 1,
    x: 34,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114708",
    width: 1,
    height: 1,
    x: 33,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114710",
    width: 1,
    height: 1,
    x: 32,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114712",
    width: 1,
    height: 1,
    x: 31,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114714",
    width: 1,
    height: 1,
    x: 30,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114716",
    width: 1,
    height: 1,
    x: 31,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114718",
    width: 1,
    height: 1,
    x: 34,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114720",
    width: 1,
    height: 1,
    x: 35,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114722",
    width: 1,
    height: 1,
    x: 36,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114724",
    width: 1,
    height: 1,
    x: 37,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114726",
    width: 1,
    height: 1,
    x: 37,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114728",
    width: 1,
    height: 1,
    x: 36,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114730",
    width: 1,
    height: 1,
    x: 35,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114732",
    width: 1,
    height: 1,
    x: 34,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114734",
    width: 1,
    height: 1,
    x: 35,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114736",
    width: 1,
    height: 1,
    x: 36,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114738",
    width: 1,
    height: 1,
    x: 36,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114740",
    width: 1,
    height: 1,
    x: 35,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114742",
    width: 1,
    height: 1,
    x: 34,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114744",
    width: 1,
    height: 1,
    x: 33,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114746",
    width: 1,
    height: 1,
    x: 32,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114748",
    width: 1,
    height: 1,
    x: 31,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114750",
    width: 1,
    height: 1,
    x: 30,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114752",
    width: 1,
    height: 1,
    x: 30,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114754",
    width: 1,
    height: 1,
    x: 29,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114756",
    width: 1,
    height: 1,
    x: 29,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114758",
    width: 1,
    height: 1,
    x: 28,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114760",
    width: 1,
    height: 1,
    x: 27,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114762",
    width: 1,
    height: 1,
    x: 29,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114764",
    width: 1,
    height: 1,
    x: 29,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114766",
    width: 1,
    height: 1,
    x: 29,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114768",
    width: 1,
    height: 1,
    x: 29,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114770",
    width: 1,
    height: 1,
    x: 28,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114772",
    width: 1,
    height: 1,
    x: 29,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114774",
    width: 1,
    height: 1,
    x: 29,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114776",
    width: 1,
    height: 1,
    x: 30,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114778",
    width: 1,
    height: 1,
    x: 30,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114780",
    width: 1,
    height: 1,
    x: 30,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114782",
    width: 1,
    height: 1,
    x: 31,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114784",
    width: 1,
    height: 1,
    x: 31,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114786",
    width: 1,
    height: 1,
    x: 31,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114788",
    width: 1,
    height: 1,
    x: 32,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114790",
    width: 1,
    height: 1,
    x: 32,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114792",
    width: 1,
    height: 1,
    x: 32,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114794",
    width: 1,
    height: 1,
    x: 33,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114796",
    width: 1,
    height: 1,
    x: 33,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114798",
    width: 1,
    height: 1,
    x: 32,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114800",
    width: 1,
    height: 1,
    x: 32,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114802",
    width: 1,
    height: 1,
    x: 33,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114804",
    width: 1,
    height: 1,
    x: 34,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114806",
    width: 1,
    height: 1,
    x: 34,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114808",
    width: 1,
    height: 1,
    x: 34,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114810",
    width: 1,
    height: 1,
    x: 33,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114812",
    width: 1,
    height: 1,
    x: 32,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114814",
    width: 1,
    height: 1,
    x: 32,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114816",
    width: 1,
    height: 1,
    x: 33,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114818",
    width: 1,
    height: 1,
    x: 33,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114820",
    width: 1,
    height: 1,
    x: 34,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114822",
    width: 1,
    height: 1,
    x: 33,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114824",
    width: 1,
    height: 1,
    x: 33,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114826",
    width: 1,
    height: 1,
    x: 32,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114828",
    width: 1,
    height: 1,
    x: 32,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114830",
    width: 1,
    height: 1,
    x: 32,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114832",
    width: 1,
    height: 1,
    x: 32,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114834",
    width: 1,
    height: 1,
    x: 32,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114836",
    width: 1,
    height: 1,
    x: 31,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114838",
    width: 1,
    height: 1,
    x: 31,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114840",
    width: 1,
    height: 1,
    x: 31,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114842",
    width: 1,
    height: 1,
    x: 31,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114844",
    width: 1,
    height: 1,
    x: 30,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114846",
    width: 1,
    height: 1,
    x: 30,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114848",
    width: 1,
    height: 1,
    x: 29,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114850",
    width: 1,
    height: 1,
    x: 28,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114852",
    width: 1,
    height: 1,
    x: 28,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114854",
    width: 1,
    height: 1,
    x: 27,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114856",
    width: 1,
    height: 1,
    x: 26,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114858",
    width: 1,
    height: 1,
    x: 26,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114860",
    width: 1,
    height: 1,
    x: 25,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114862",
    width: 1,
    height: 1,
    x: 23,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114864",
    width: 1,
    height: 1,
    x: 24,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114866",
    width: 1,
    height: 1,
    x: 25,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114868",
    width: 1,
    height: 1,
    x: 23,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114870",
    width: 1,
    height: 1,
    x: 23,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114872",
    width: 1,
    height: 1,
    x: 23,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114874",
    width: 1,
    height: 1,
    x: 23,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114876",
    width: 1,
    height: 1,
    x: 23,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114878",
    width: 1,
    height: 1,
    x: 23,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114880",
    width: 1,
    height: 1,
    x: 27,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114882",
    width: 1,
    height: 1,
    x: 23,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114884",
    width: 1,
    height: 1,
    x: 23,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114886",
    width: 1,
    height: 1,
    x: 23,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114888",
    width: 1,
    height: 1,
    x: 23,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114890",
    width: 1,
    height: 1,
    x: 23,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114892",
    width: 1,
    height: 1,
    x: 22,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114894",
    width: 1,
    height: 1,
    x: 25,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114896",
    width: 1,
    height: 1,
    x: 20,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114898",
    width: 1,
    height: 1,
    x: 18,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114900",
    width: 1,
    height: 1,
    x: 15,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114902",
    width: 1,
    height: 1,
    x: 16,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114904",
    width: 1,
    height: 1,
    x: 17,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114906",
    width: 1,
    height: 1,
    x: 18,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114908",
    width: 1,
    height: 1,
    x: 22,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114910",
    width: 1,
    height: 1,
    x: 23,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114912",
    width: 1,
    height: 1,
    x: 24,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114914",
    width: 1,
    height: 1,
    x: 25,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114916",
    width: 1,
    height: 1,
    x: 25,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114918",
    width: 1,
    height: 1,
    x: 26,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114920",
    width: 1,
    height: 1,
    x: 27,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114922",
    width: 1,
    height: 1,
    x: 22,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114924",
    width: 1,
    height: 1,
    x: 21,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114926",
    width: 1,
    height: 1,
    x: 21,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114928",
    width: 1,
    height: 1,
    x: 20,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114930",
    width: 1,
    height: 1,
    x: 20,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114932",
    width: 1,
    height: 1,
    x: 19,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114934",
    width: 1,
    height: 1,
    x: 19,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114936",
    width: 1,
    height: 1,
    x: 18,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114938",
    width: 1,
    height: 1,
    x: 17,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114940",
    width: 1,
    height: 1,
    x: 17,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114942",
    width: 1,
    height: 1,
    x: 16,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114944",
    width: 1,
    height: 1,
    x: 15,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114946",
    width: 1,
    height: 1,
    x: 14,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114948",
    width: 1,
    height: 1,
    x: 14,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114950",
    width: 1,
    height: 1,
    x: 15,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114952",
    width: 1,
    height: 1,
    x: 14,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114954",
    width: 1,
    height: 1,
    x: 13,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114956",
    width: 1,
    height: 1,
    x: 12,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114958",
    width: 1,
    height: 1,
    x: 11,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114960",
    width: 1,
    height: 1,
    x: 11,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114962",
    width: 1,
    height: 1,
    x: 11,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114964",
    width: 1,
    height: 1,
    x: 10,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114966",
    width: 1,
    height: 1,
    x: 9,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114968",
    width: 1,
    height: 1,
    x: 8,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114970",
    width: 1,
    height: 1,
    x: 10,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114972",
    width: 1,
    height: 1,
    x: 10,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114974",
    width: 1,
    height: 1,
    x: 9,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114976",
    width: 1,
    height: 1,
    x: 10,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114978",
    width: 1,
    height: 1,
    x: 10,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114980",
    width: 1,
    height: 1,
    x: 11,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114982",
    width: 1,
    height: 1,
    x: 12,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114984",
    width: 1,
    height: 1,
    x: 13,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114986",
    width: 1,
    height: 1,
    x: 15,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114988",
    width: 1,
    height: 1,
    x: 17,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114990",
    width: 1,
    height: 1,
    x: 16,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114992",
    width: 1,
    height: 1,
    x: 15,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114994",
    width: 1,
    height: 1,
    x: 15,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114996",
    width: 1,
    height: 1,
    x: 14,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect114998",
    width: 1,
    height: 1,
    x: 14,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115000",
    width: 1,
    height: 1,
    x: 13,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115002",
    width: 1,
    height: 1,
    x: 12,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115004",
    width: 1,
    height: 1,
    x: 12,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115006",
    width: 1,
    height: 1,
    x: 11,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115008",
    width: 1,
    height: 1,
    x: 11,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115010",
    width: 1,
    height: 1,
    x: 12,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115012",
    width: 1,
    height: 1,
    x: 13,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115014",
    width: 1,
    height: 1,
    x: 13,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115016",
    width: 1,
    height: 1,
    x: 14,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115018",
    width: 1,
    height: 1,
    x: 14,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115020",
    width: 1,
    height: 1,
    x: 15,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115022",
    width: 1,
    height: 1,
    x: 15,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115024",
    width: 1,
    height: 1,
    x: 16,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115026",
    width: 1,
    height: 1,
    x: 16,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115028",
    width: 1,
    height: 1,
    x: 17,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115030",
    width: 1,
    height: 1,
    x: 18,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115032",
    width: 1,
    height: 1,
    x: 19,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115034",
    width: 1,
    height: 1,
    x: 19,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115036",
    width: 1,
    height: 1,
    x: 21,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115038",
    width: 1,
    height: 1,
    x: 22,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115040",
    width: 1,
    height: 1,
    x: 23,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115042",
    width: 1,
    height: 1,
    x: 25,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115044",
    width: 1,
    height: 1,
    x: 26,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115046",
    width: 1,
    height: 1,
    x: 25,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115048",
    width: 1,
    height: 1,
    x: 28,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115050",
    width: 1,
    height: 1,
    x: 28,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115052",
    width: 1,
    height: 1,
    x: 29,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115054",
    width: 1,
    height: 1,
    x: 29,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115056",
    width: 1,
    height: 1,
    x: 30,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115058",
    width: 1,
    height: 1,
    x: 29,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115060",
    width: 1,
    height: 1,
    x: 29,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115062",
    width: 1,
    height: 1,
    x: 29,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115064",
    width: 1,
    height: 1,
    x: 29,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115066",
    width: 1,
    height: 1,
    x: 29,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115068",
    width: 1,
    height: 1,
    x: 29,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115070",
    width: 1,
    height: 1,
    x: 30,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115072",
    width: 1,
    height: 1,
    x: 31,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115074",
    width: 1,
    height: 1,
    x: 31,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115076",
    width: 1,
    height: 1,
    x: 31,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115078",
    width: 1,
    height: 1,
    x: 31,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115080",
    width: 1,
    height: 1,
    x: 30,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115082",
    width: 1,
    height: 1,
    x: 30,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115084",
    width: 1,
    height: 1,
    x: 30,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115086",
    width: 1,
    height: 1,
    x: 30,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115088",
    width: 1,
    height: 1,
    x: 30,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115090",
    width: 1,
    height: 1,
    x: 28,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115092",
    width: 1,
    height: 1,
    x: 28,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115094",
    width: 1,
    height: 1,
    x: 27,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115096",
    width: 1,
    height: 1,
    x: 27,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115098",
    width: 1,
    height: 1,
    x: 27,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115100",
    width: 1,
    height: 1,
    x: 27,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115102",
    width: 1,
    height: 1,
    x: 26,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115104",
    width: 1,
    height: 1,
    x: 25,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115106",
    width: 1,
    height: 1,
    x: 25,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115108",
    width: 1,
    height: 1,
    x: 26,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115110",
    width: 1,
    height: 1,
    x: 26,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115112",
    width: 1,
    height: 1,
    x: 25,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115114",
    width: 1,
    height: 1,
    x: 25,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115116",
    width: 1,
    height: 1,
    x: 26,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115118",
    width: 1,
    height: 1,
    x: 26,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115120",
    width: 1,
    height: 1,
    x: 25,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115122",
    width: 1,
    height: 1,
    x: 24,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115124",
    width: 1,
    height: 1,
    x: 24,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115126",
    width: 1,
    height: 1,
    x: 24,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115128",
    width: 1,
    height: 1,
    x: 24,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115130",
    width: 1,
    height: 1,
    x: 24,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115132",
    width: 1,
    height: 1,
    x: 23,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115134",
    width: 1,
    height: 1,
    x: 22,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115136",
    width: 1,
    height: 1,
    x: 21,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115138",
    width: 1,
    height: 1,
    x: 20,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115140",
    width: 1,
    height: 1,
    x: 20,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115142",
    width: 1,
    height: 1,
    x: 19,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115144",
    width: 1,
    height: 1,
    x: 18,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115146",
    width: 1,
    height: 1,
    x: 17,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115148",
    width: 1,
    height: 1,
    x: 18,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115150",
    width: 1,
    height: 1,
    x: 19,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115152",
    width: 1,
    height: 1,
    x: 19,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115154",
    width: 1,
    height: 1,
    x: 18,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115156",
    width: 1,
    height: 1,
    x: 17,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115158",
    width: 1,
    height: 1,
    x: 16,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115160",
    width: 1,
    height: 1,
    x: 15,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115162",
    width: 1,
    height: 1,
    x: 15,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115164",
    width: 1,
    height: 1,
    x: 16,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115166",
    width: 1,
    height: 1,
    x: 16,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115168",
    width: 1,
    height: 1,
    x: 17,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115170",
    width: 1,
    height: 1,
    x: 17,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115172",
    width: 1,
    height: 1,
    x: 18,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115174",
    width: 1,
    height: 1,
    x: 18,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115178",
    width: 1,
    height: 1,
    x: 19,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115180",
    width: 1,
    height: 1,
    x: 19,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115182",
    width: 1,
    height: 1,
    x: 19,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115184",
    width: 1,
    height: 1,
    x: 20,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115186",
    width: 1,
    height: 1,
    x: 21,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115188",
    width: 1,
    height: 1,
    x: 22,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115190",
    width: 1,
    height: 1,
    x: 23,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115192",
    width: 1,
    height: 1,
    x: 23,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115196",
    width: 1,
    height: 1,
    x: 23,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115198",
    width: 1,
    height: 1,
    x: 23,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115200",
    width: 1,
    height: 1,
    x: 23,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115202",
    width: 1,
    height: 1,
    x: 22,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115204",
    width: 1,
    height: 1,
    x: 21,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115206",
    width: 1,
    height: 1,
    x: 20,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115208",
    width: 1,
    height: 1,
    x: 20,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115210",
    width: 1,
    height: 1,
    x: 20,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115212",
    width: 1,
    height: 1,
    x: 20,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115214",
    width: 1,
    height: 1,
    x: 20,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115218",
    width: 1,
    height: 1,
    x: 21,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115220",
    width: 1,
    height: 1,
    x: 21,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115222",
    width: 1,
    height: 1,
    x: 22,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115224",
    width: 1,
    height: 1,
    x: 22,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115226",
    width: 1,
    height: 1,
    x: 22,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115228",
    width: 1,
    height: 1,
    x: 21,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5,
      strokeWidth: 0.989851
    },
    id: "rect115230",
    width: 1,
    height: 1,
    x: 21,
    y: 22
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlamingo);
export default __webpack_public_path__ + "static/media/flamingo.d0919e131ac45910033732b980325efe.svg";
export { ForwardRef as ReactComponent };